import { FileClock } from 'lucide-react';

type Props = {
  onWiederherstellen: () => void;
  onVerwerfen: () => void;
  /** Optionaler Zusatz, z. B. worum es im Entwurf geht. */
  text?: string;
};

// Angebot statt Automatik (S-1): ein gefundener Entwurf wird gezeigt und
// muss aktiv uebernommen werden.
export function DraftHinweis({ onWiederherstellen, onVerwerfen, text }: Props) {
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-2 rounded-md border border-gold bg-gold-soft px-3 py-2 text-sm">
      <FileClock className="h-4 w-4 shrink-0 text-gold-dark" aria-hidden />
      <span className="text-ink">
        Nicht gespeicherter Entwurf gefunden{text ? ` — ${text}` : ''}.
      </span>
      <span className="ml-auto flex gap-2">
        <button
          type="button"
          onClick={onWiederherstellen}
          className="min-h-[44px] rounded px-2 font-medium text-akzent hover:text-akzent-stark"
        >
          Wiederherstellen
        </button>
        <button
          type="button"
          onClick={onVerwerfen}
          className="min-h-[44px] rounded px-2 text-ink-soft hover:text-coral"
        >
          Verwerfen
        </button>
      </span>
    </div>
  );
}
